import React from "react";

const ReloadIcon = ({ viewBox = "0 0 18 18", className = "hayley-h-[16px] hayley-w-[16px] hayley-text-inherit" }) => {
  return (
    <svg data-testid="home-icon" viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M17 8.46667L9 1L1 8.46667" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M3.13336 9.5332V16.9999H7.40003V12.7332H10.6V16.9999H14.8667V9.5332"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReloadIcon;
